function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/classCallCheck.js
// module id = 3
// module chunks = 1 2